import type { AppProps } from "next/app";
import { I18nProvider } from "next-localization";
import { SitecorePageProps } from "lib/page-props";
import { ChakraProvider } from "@chakra-ui/react";

import theme from "themes/index";
import { SpeedInsights } from "@vercel/speed-insights/next";

function App({ Component, pageProps }: AppProps<SitecorePageProps>) {
    const { dictionary, ...rest } = pageProps;

    return (
        <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
            <ChakraProvider theme={theme}>
                <Component {...rest} />
                <SpeedInsights />
            </ChakraProvider>
        </I18nProvider>
    );
}

export default App;
